import React from "react";
import { connect } from "react-redux";
import type { RootState } from "redux/reducers";
import Auth from "features/authentication/Auth";
import toggleUtils from "shared/toggleUtils";
import type { ToggleFeature } from "shared/types";
import ForageCycleManagementPage from "features/manejo/views/ForageCycleManagementPage";
import ForageOptionsCsv from "./ForageOptionsCsv";

function ForageOptions({ toggles }: { toggles: ToggleFeature[] | null }) {
  const session = Auth.getSession();
  if (!session?.permissions?.cadastrar_ciclo_forragem) {
    return null;
  }

  if (toggleUtils.isForageCycleManagementActive(toggles)) {
    return <ForageCycleManagementPage />;
  }

  return <ForageOptionsCsv />;
}

const mapStateToProps = (state: RootState) => ({
  toggles: state.fazenda.Toggles,
});

export default connect(mapStateToProps)(ForageOptions);
